'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTempKey = exports.makeTempKey = undefined;

var _internal = require('./internal');

let tempKeyCounter = 0;
let makeTempKey = exports.makeTempKey = () => (0, _internal.internal)(Date.now() + '_' + ++tempKeyCounter + '_TEMP');
let isTempKey = exports.isTempKey = key => (0, _internal.isInternal)(key) && /_TEMP$/.test(key);
//# sourceMappingURL=tempKey.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/utils/tempKey.js